import React from 'react';
interface Props {
  fillColor?: string;
}
function DiabetesIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none">
      <g clipPath="url(#clip0_847_3028)">
        <path
          d="M7 3.85547H7.5C8.88125 3.85547 10 2.73672 10 1.35547V0.855469C10 0.580469 9.775 0.355469 9.5 0.355469H9C7.61875 0.355469 6.5 1.47422 6.5 2.85547V3.35547C6.5 3.63047 6.725 3.85547 7 3.85547ZM1.5 9.35547C1.5 8.36484 1.7375 7.40234 2.1375 6.73984C2.51562 6.11484 2.95937 5.85547 3.5 5.85547C4.05625 5.85547 4.85 6.08672 5.54063 6.35547C6.47813 6.72109 7.525 6.72109 8.4625 6.35547C9.15312 6.08672 9.94688 5.85547 10.5031 5.85547C11.0437 5.85547 11.4875 6.11484 11.8656 6.73984C12.2625 7.40234 12.5 8.36484 12.5 9.35547C12.5 11.0492 11.9688 12.4805 11.2375 13.4555C10.4875 14.4555 9.6375 14.8555 9 14.8555C8.85625 14.8555 8.575 14.8023 8.22188 14.6961C7.42813 14.4586 6.575 14.4586 5.78125 14.6961C5.42812 14.8023 5.14688 14.8555 5.00313 14.8555C4.36563 14.8555 3.51562 14.4555 2.76562 13.4555C2.03125 12.4805 1.5 11.0492 1.5 9.35547ZM3.5 4.35547C1.11562 4.35547 0 6.97109 0 9.35547C0 13.3555 2.5 16.3555 5 16.3555C5.37187 16.3555 5.82812 16.2492 6.2125 16.1336C6.725 15.9805 7.27813 15.9805 7.79063 16.1336C8.17188 16.2492 8.62813 16.3555 9.00313 16.3555C11.5031 16.3555 14.0031 13.3555 14.0031 9.35547C14.0031 6.97109 12.8875 4.35547 10.5031 4.35547C9.65 4.35547 8.6375 4.67734 7.91875 4.95859C7.33125 5.18672 6.67188 5.18672 6.08437 4.95859C5.36562 4.67734 4.35313 4.35547 3.5 4.35547Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3028">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DiabetesIcon;
